import { useContext, useEffect, useState } from 'react';
import { FaArrowRotateRight } from 'react-icons/fa6';

import useServerArea from '../../../api/useServerArea';
import useServer from '../../../api/useServerMain';
import Checkbox from '../../../components/forms/Checkbox';
import Button from '../../../components/misc/Button';
import SpinnerLoading from '../../../components/misc/SpinnerLoading';
import { BasicNomenclator } from '../../../interfaces/ServerInterfaces';
import { useAppSelector } from '../../../store/hooks';
import { DetailProductContext } from '../DetailProductContainer';

//Case Addon, Service, Menu ---------------------------------------------------------------------------

const Processed = () => {
  const { denyRoles } = useServer()
  const { getAllAreas, allAreas, isLoading } = useServerArea()
  const { product, updateProduct } = useContext(DetailProductContext)
  const [selected, setSelected] = useState<BasicNomenclator[]>([])
  const { business } = useAppSelector((state) => state.init)

  useEffect(() => {
    business?.subscriptionPlan.code !== 'FREE' &&
      getAllAreas(
        { type: 'MANUFACTURER', all_data: true, inAllMyBusiness: true },
        true
      )
    setSelected(product?.listProductionAreas.map((item) => item) ?? [])
  }, [])

  //Checkbox Management-----------------------------------------------------------------------------------
  const checkData: BasicNomenclator[] = []
  allAreas?.forEach((item) =>
    checkData.push({
      id: item.id,
      name:
        business?.name === item?.business?.name
          ? (item.name ?? '')
          : `${item.name ?? ''}: ${item?.business?.name ?? ''}`,
    })
  )

  const updateListProd = () => {
    updateProduct &&
      updateProduct(product?.id, {
        listProductionAreas: selected.map((item) => item.id),
      })
  }

  //-------------------------------------------------------------------------------------------------------
  if (isLoading)
    return (
      <div className="flex h-[34rem] items-center justify-center rounded-md border border-slate-300">
        <SpinnerLoading />
      </div>
    )
  return (
    <>
      <div className="h-[34rem] overflow-auto rounded-md border border-slate-300 p-5 scrollbar-thin scrollbar-thumb-gray-200">
        <Checkbox
          data={checkData}
          selected={selected}
          setSelected={setSelected}
        />
      </div>
      <div className="mt-2 flex justify-end">
        {/* <Button name="Actualizar" color="slate-600" action={updateListProd} /> */}
        {denyRoles(['AUDITOR']) && (
          <Button
            icon={<FaArrowRotateRight className={`h-5`} />}
            name="Actualizar"
            color="slate-600"
            type="button"
            action={updateListProd}
          />
        )}
      </div>
    </>
  )
}

export default Processed
